import { Component, ReactNode } from "react";

import moment from "moment"

import { NUMBER_PATTERN, isValid } from '../../libs/validation/stringRegex'
import { numberValidation } from '../../libs/validation/remoteValidationAbstract'

import AddressInput from "../address/Address";
import SiNo, { SiNoType, getBoolean, getSiNoValue } from "../siNo/SiNo";

import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'

interface BuildingDataProps {
    superfice: number | undefined
    uso: string | undefined
    tipo: string | undefined
    piani: number | undefined
    piano: number | undefined

    annoCostruzione: string | undefined
    isRistrutturato?: boolean | undefined
    annoRistrutturazione?: number | undefined

    indirizzo: string | undefined
    street: string | undefined
    street_number: string | undefined
    zip: string | undefined
    city: string | undefined

    is_manual_address?: boolean
    updateManualSelectionCallBack?: Function

    anni: any
    utilizzi: any
    tipologie: any

    superficeError: string | undefined
    usoError: string | undefined
    tipoError: string | undefined
    pianiError: string | undefined
    pianoError: string | undefined
    annoCostruzioneError: string | undefined
    isRistrutturatoError: string | undefined
    annoRistrutturazioneError?: string | undefined

    indirizzoError: string | undefined
    streetError: string | undefined
    street_numberError: string | undefined
    zipError: string | undefined
    cityError: string | undefined

    updateSuperficeCallBack: Function
    updateUsoCallBack: Function
    updateTipoCallBack: Function
    updatePianiCallBack: Function
    updatePianoCallBack: Function

    updateAnnoCostruzioneCallBack?: Function
    updateIsRistrutturato?: Function
    updateAnnoRistrutturazione?: Function

    updateAll: Function
    updateStreet: Function
    updateNumber: Function
    updateZip: Function
    updateCity: Function

    annoRistrutturazioneValidationCallback?: Function
    
    expiredSessionCallbak: Function
}

interface BuildingDataState {
    pianiError: string | undefined
    annoRistrutturazioneError: string |  undefined
    is_manual_address: boolean
}

class BuildingData extends Component<BuildingDataProps, BuildingDataState> {

    constructor (props: any) {
        super (props)

        this.state = {
            pianiError: undefined,
            annoRistrutturazioneError: this.props.annoRistrutturazioneError,
            is_manual_address: (this.props.is_manual_address !== undefined) ? this.props.is_manual_address : false
        }

        this.pianiValidation = this.pianiValidation.bind(this)
        this.pianoValidation = this.pianoValidation.bind(this)
        this.clearPianiError = this.clearPianiError.bind(this)
        this.mqValidation = this.mqValidation.bind(this)

        this.updateIsRistrutturato = this.updateIsRistrutturato.bind(this)
        this.annoRistrutturazioneValidation = this.annoRistrutturazioneValidation.bind(this)
        this.clearAnnoRistrutturazioneError = this.clearAnnoRistrutturazioneError.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<BuildingDataProps>, prevState: Readonly<BuildingDataState>, snapshot?: any): void {
        if (
            this.props.is_manual_address !== undefined &&
            this.props.is_manual_address !== prevProps.is_manual_address &&
            this.props.is_manual_address !== this.state.is_manual_address &&
            this.props.is_manual_address !== prevState.is_manual_address
        ) {
            this.setState({
                is_manual_address: this.props.is_manual_address
            })
        }
        if (
            this.props.annoCostruzione !== undefined &&
            this.props.annoRistrutturazione !== undefined &&
            prevProps.annoCostruzione !== this.props.annoCostruzione
        ) {
            this.annoRistrutturazioneValidation ()
        }
    }

    render (): ReactNode {
        return (
            <>
                <div className="col-12">
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <Input 
                                id="superfice" name='superfice'
                                label='Superficie Immobile (mq lordi)'
                                value={this.props.superfice?.toString()}
                                type='number'
                                step='1'
                                min='1'
                                max='1000'
                                onInput={
                                    (e: any) => {
                                        if (e.currentTarget?.value) {
                                            const valNumber = Number(e.currentTarget.value)

                                            if (valNumber < 1) e.currentTarget.value = 1
                                            if (valNumber > 1000) e.currentTarget.value = 1000
                                        }
                                    }
                                        
                                }
                                regexp={this.mqValidation}
                                remoteValidation={numberValidation}
                                errorDisplayMsg={'Valore non valido'}
                                callback={this.props.updateSuperficeCallBack}
                                error={this.props.superficeError}
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <Select
                                id='uso' name='uso'
                                label='Tipologia d’uso' 
                                value={this.props.uso}
                                options={this.props.utilizzi}
                                callback={this.props.updateUsoCallBack}
                                error={this.props.usoError}
                            />
                        </div>
                    </div>

                    <Select
                        id='tipo' name='tipo'
                        label='Tipologia Immobile' 
                        value={this.props.tipo}
                        options={this.props.tipologie}
                        callback={this.props.updateTipoCallBack}
                        error={this.props.tipoError}
                    />

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <Input 
                                id="piani" name='piani' key={'piani'}
                                label='Numero totali di piani abitazione'
                                value={this.props.piani?.toString()}
                                type='number'
                                step='1'
                                min='1'
                                max='200'
                                regexp={NUMBER_PATTERN}
                                remoteValidation={this.pianiValidation}
                                errorDisplayMsg={this.state.pianiError ?? 'Valore non valido'}
                                callback={this.props.updatePianiCallBack}
                                error={this.state.pianiError ?? this.props.pianiError}
                                onFocus={this.clearPianiError}
                                onInput={
                                    (e: any) => {
                                        if (e.currentTarget?.value) {
                                            const valNumber = Number(e.currentTarget.value)

                                            if (valNumber < 1) e.currentTarget.value = 1
                                            if (valNumber > 200) e.currentTarget.value = 200
                                        }
                                    }
                                        
                                }
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <Input 
                                id="piano" name='piano' key={'piano'}
                                label='Piano abitazione'
                                value={this.props.piano?.toString()}
                                type='number'
                                step='1'
                                min='1'
                                regexp={NUMBER_PATTERN}
                                remoteValidation={this.pianoValidation}
                                errorDisplayMsg={this.state.pianiError ?? 'Valore non valido'}
                                callback={this.props.updatePianoCallBack}
                                error={this.state.pianiError ?? this.props.pianoError}
                                onFocus={this.clearPianiError}
                            />
                        </div>
                    </div>

                    <Select
                        id='anno' name='anno'
                        label='Anno di costruzione' 
                        value={this.props.annoCostruzione}
                        options={this.props.anni}
                        callback={this.props.updateAnnoCostruzioneCallBack}
                        error={this.props.annoCostruzioneError}
                    />

                    { this.props.updateIsRistrutturato !== undefined &&
                        <>
                            <SiNo 
                                id='isRistrutturato' name="isRistrutturato"
                                label='L’immobile è stato ristrutturato?'
                                value={ getSiNoValue( this.props.isRistrutturato ) }
                                callback={this.updateIsRistrutturato}
                                error={this.props.isRistrutturatoError}
                            />
                            { this.props.isRistrutturato === true &&
                                <Input
                                    id="annoRistrutturazione" name="annoRistrutturazione"
                                    label="Anno ristrutturazione"
                                    value={this.props.annoRistrutturazione?.toString()}
                                    type="number"
                                    maxLength={4} max={moment().year()} 
                                    callback={this.props.updateAnnoRistrutturazione}
                                    regexp={NUMBER_PATTERN}
                                    remoteValidation={this.annoRistrutturazioneValidation}
                                    error={this.state.annoRistrutturazioneError ?? this.props.annoRistrutturazioneError}
                                    onFocus={this.clearAnnoRistrutturazioneError}
                                    onInput={
                                        (e: any) => {
                                            if (e.currentTarget?.value) {
                                                const valNumber = Number(e.currentTarget.value)

                                                if (valNumber > moment().year()) e.currentTarget.value = moment().year()
                                            }
                                        }
                                    }
                                />
                            }
                        </>
                    }

                    <div className="row">
                        <AddressInput 
                            value={this.props.indirizzo}
                            street={this.props.street}
                            number={this.props.street_number}
                            zip={this.props.zip}
                            city={this.props.city}

                            is_manual_address={this.state.is_manual_address}
                            updateManualSelectionCallBack={this.props.updateManualSelectionCallBack}

                            error={this.props.indirizzoError}
                            streetError={this.props.streetError}
                            numberError={this.props.street_numberError}
                            zipError={this.props.zipError}
                            cityError={this.props.cityError}

                            updateAll={this.props.updateAll}
                            updateStreet={this.props.updateStreet}
                            updateNumber={this.props.updateNumber}
                            updateZip={this.props.updateZip}
                            updateCity={this.props.updateCity}
                            
                            expiredSessionCallbak={this.props.expiredSessionCallbak}

                            id='indirizzo_immobile'
                            label="Cerca l'indirizzo dell'immobile"
                        />
                    </div>

                </div>
            </>
        )
    }

    private pianiValidation (val: number | undefined) {
        let error = false

        if (val !== undefined) {
            if (this.props.piano === undefined) {
                error =  (Number(val) < 0 || Number(val) > 200)
            } 
            else {
                error = ((Number(val) < 0 || Number(val) > 200) || Number(val) < Number(this.props.piano))
            }
        }

        this.setState ({
            pianiError: error ? 'Combinazione non valida' : undefined,
        })

        return error
    }
    private pianoValidation (val: number | undefined) {
        let error = false

        if (val !== undefined) {
            if (this.props.piani === undefined) {
                error =  (Number(val) < 0)
            } 
            else {
                error = (Number(val) < 0 || Number(val) > Number(this.props.piani))
            }
        }

        this.setState ({
            pianiError: error ? 'Combinazione non valida' : undefined,
        })

        return error
    }
    private clearPianiError () {
        this.setState ({
            pianiError: undefined,
        })
    }

    private mqValidation (val: string | undefined) {
        if (val !== undefined && isValid(val, NUMBER_PATTERN)) {
            return Number(val) <= 1000
        }
    }

    private updateIsRistrutturato (val: SiNoType) {
        if (this.props.updateIsRistrutturato) {
            this.props.updateIsRistrutturato(
                getBoolean( val )
            )
        }
    }

    private annoRistrutturazioneValidation () {
        if (this.props.annoRistrutturazioneValidationCallback) {
            this.setState ({
                annoRistrutturazioneError: this.props.annoRistrutturazioneValidationCallback()
            })
        }
    }
    private clearAnnoRistrutturazioneError () {
        this.setState ({
            annoRistrutturazioneError: undefined
        })
    }
}

export default BuildingData